module.exports = __webpack_public_path__ + "img/new_spotd5.f9596c8c.gif";